import { Select, MenuItem, SelectChangeEvent, Typography } from '@mui/material';

export interface SelectOption {
  id: string;
  label: string;
}

interface SelectProps {
  value: string | undefined;
  options: SelectOption[];
  onChange: (id: string) => void;
}

export const SelectItem = ({ value, options, onChange }: SelectProps) => {
  const handleOnChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    onChange(value);
  };
  return (
    <Select
      value={value || ''}
      onChange={handleOnChange}
      sx={{
        minWidth: 250,
        maxWidth: '100%',
        '& .MuiSelect-select': {
          whiteSpace: 'pre-wrap',
          overflowWrap: 'break-word',
          wordWrap: 'break-word',
          wordBreak: 'break-all',
          padding: '8px 14px',
          hyphens: 'auto',
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          lineHeight: '1.5',
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            maxHeight: 300,
            maxWidth: '90vw',
          },
        },
      }}
    >
      {options.map((option) => (
        <MenuItem
          key={option.id}
          value={option.id}
          sx={{
            whiteSpace: 'pre-wrap',
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            wordBreak: 'break-all',
            padding: '8px 14px',
            hyphens: 'auto',
          }}
        >
          <Typography
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: '1.5',
              width: '100%',
            }}
          >
            {option.label}
          </Typography>
        </MenuItem>
      ))}
    </Select>
  );
};
